import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { getAppRoot } from "@/onload/loadConfig";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowImage',
    props: {
        workflowId: null,
        workflowVersion: { default: null },
        size: { default: "lg" }
    },
    setup(__props) {
        const props = __props;
        const src = computed(() => {
            let extraArgs = "";
            if (props.workflowVersion) {
                extraArgs = `&version=${props.workflowVersion}`;
            }
            return `${getAppRoot()}workflow/gen_image?id=${props.workflowId}&embed=true${extraArgs}`;
        });
        const width = computed(() => {
            const size = props.size;
            if (size == "sm") {
                return "300px";
            }
            else if (size == "md") {
                return "550px";
            }
            else {
                return "100%";
            }
        });
        return { __sfc: true, props, src, width };
    }
});
